/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Data_MealAllergensCheckbox } from './Data_MealAllergensCheckbox';
import type { Data_MealDietCheckbox } from './Data_MealDietCheckbox';
export type Data_Meal = {
    /**
     * Meal name.
     */
    name?: string;
    /**
     * Meal price.
     */
    price?: number;
    /**
     * Meal weight.
     */
    amount?: string;
    /**
     * Meal food type. Typ jídla 1=polévka, 2=hlavní jídlo, 3=desert, 5=snídaně
     */
    foodType?: Data_Meal.foodType;
    /**
     * Meal diet.
     */
    dietCheckboxes?: Array<Data_MealDietCheckbox>;
    /**
     * Meal allergens.
     */
    allergensCheckboxes?: Array<Data_MealAllergensCheckbox>;
};
export namespace Data_Meal {
    /**
     * Meal food type. Typ jídla 1=polévka, 2=hlavní jídlo, 3=desert, 5=snídaně
     */
    export enum foodType {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_5' = 5,
    }
}

